<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Testimonial</p>
            <div>
              <el-tooltip content="Insert" placement="top">
                <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click="insert()"
                ></el-button>
              </el-tooltip>  
              <Dialog />   
            </div>          
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/testimonial/Table'
import Dialog from '../components/testimonial/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('testimonial', ['loading'])
  },

  methods: {   
    ...mapMutations('testimonial', [
      'setDialog',
      'setSelectedTestimonial'
    ]),    
    initialTestimonial(){
      return {
        id: null,
        full_name: '',
        user_type_id: null,
        content: null,
        rating: 0,
        image_url: null,
        position: 1,
        link: null,
        link_youtube: null
      }
    },
    insert(){
      this.setDialog(true)
      this.setSelectedTestimonial(this.initialTestimonial())
    }  
  }
}
</script>
